import { useState } from 'react';
import { Search, Book, MessageCircle, FileText, ChevronDown, Mail, Clock, Phone } from 'lucide-react';
import './SupportPages.css';

const HelpPage = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [openFaq, setOpenFaq] = useState(null);

  const categories = [
    { icon: Book, title: 'Getting Started', articles: 12 },
    { icon: MessageCircle, title: 'Trading Guide', articles: 8 },
    { icon: FileText, title: 'Account & Security', articles: 15 },
    { icon: Clock, title: 'Transaction Issues', articles: 10 },
  ];

  const faqs = [
    { q: 'How do I create an exchange?', a: 'Simply select the currencies you want to exchange, enter the amount, provide your wallet address, and confirm the transaction.' },
    { q: 'How long does an exchange take?', a: 'Most exchanges are completed within 2-10 minutes depending on the blockchain confirmation times.' },
    { q: 'What if I sent the wrong amount?', a: 'Contact our support team immediately. In most cases, we can refund or adjust the exchange.' },
    { q: 'Is KYC required?', a: 'No KYC is required for exchanges under $10,000. Higher amounts may require verification.' },
    { q: 'How do I track my exchange?', a: 'Use the transaction ID provided after creating an exchange to track its status on our platform.' },
  ];

  return (
    <div className="support-page">
      <div className="support-bg">
        <div className="support-glow"></div>
      </div>

      <div className="support-container">
        {/* Hero */}
        <section className="support-hero">
          <h1 className="support-title">
            How Can We <span className="gradient-text">Help?</span>
          </h1>
          <div className="search-box-large">
            <Search size={24} />
            <input
              type="text"
              placeholder="Search for answers..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </section>

        {/* Categories */}
        <section className="categories-section">
          <h2>Browse by Category</h2>
          <div className="categories-grid">
            {categories.map((cat, index) => (
              <div key={index} className="category-card" style={{ animationDelay: `${index * 0.1}s` }}>
                <cat.icon size={32} />
                <h3>{cat.title}</h3>
                <p>{cat.articles} articles</p>
              </div>
            ))}
          </div>
        </section>

        {/* FAQs */}
        <section className="faqs-section">
          <h2>Frequently Asked Questions</h2>
          <div className="faqs-list">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className={`faq-item ${openFaq === index ? 'open' : ''}`}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <button className="faq-question" onClick={() => setOpenFaq(openFaq === index ? null : index)}>
                  <span>{faq.q}</span>
                  <ChevronDown size={20} className="faq-chevron" />
                </button>
                <div className="faq-answer">
                  <p>{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Contact Cards */}
        <section className="contact-section">
          <h2>Still Need Help?</h2>
          <div className="contact-cards">
            <div className="contact-card">
              <Mail size={32} />
              <h3>Email Support</h3>
              <p>support@omnibridge.com</p>
              <span className="response-time">Response within 24h</span>
            </div>
            <div className="contact-card">
              <MessageCircle size={32} />
              <h3>Live Chat</h3>
              <p>Chat with our team</p>
              <span className="response-time">Usually responds in 5m</span>
            </div>
            <div className="contact-card">
              <Phone size={32} />
              <h3>Phone Support</h3>
              <p>+1 (888) 123-4567</p>
              <span className="response-time">24/7 available</span>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default HelpPage;
